import axios, { AxiosRequestConfig } from 'axios';

export class HttpEndpoint {
    private applicationUrl: string;

    public constructor(applicationUrl: string) {
        if (applicationUrl.endsWith('/')) {
            applicationUrl = applicationUrl.substring(0, applicationUrl.length - 1);
        }
        this.applicationUrl = applicationUrl;
    }

    public getEndpointUrl(endpointPath: string): string {
        let result = this.applicationUrl;
        if (endpointPath.startsWith('http')) {
            return endpointPath;
        } else if (!endpointPath.startsWith('/')) {
            result += '/';
        }
        result += endpointPath;
        return result;
    }

    public buildPathWithQuery(
        path: string,
        query: { [key: string]: string | undefined }
    ): string {
        let result = path;
        let first = true;
        for (const property of Object.keys(query)) {
            if (query && query[property] && query[property]!.trim()?.length > 0) {
                if (first) {
                    result += '?';
                    first = false;
                } else {
                    result += '&';
                }
                result += encodeURIComponent(property);
                result += '=';
                result += encodeURIComponent(query[property]!);
            }
        }
        return result;
    }

    public async post<T>(endpointPath: string, data?: any, config?: AxiosRequestConfig) {
        const result = await axios.post<T>(this.getEndpointUrl(endpointPath), data, config);
        return result.data;
    }

    public async postWithResponse<T>(
        endpointPath: string,
        data?: any,
        config?: AxiosRequestConfig
    ) {
        return await axios.post<T>(this.getEndpointUrl(endpointPath), data, config);
    }

    public async get<T>(endpointPath: string, config?: AxiosRequestConfig) {
        const result = await axios.get<T>(this.getEndpointUrl(endpointPath), config);
        return result.data;
    }
}
